import { ChangePasswordComponent } from "./ChangePassword";

const ChangePassword = ChangePasswordComponent;

export default ChangePassword;
